import React, { useRef, useState } from "react";
import BackIcon from "@/images/back_arrow.svg";
import { ButtonWithLoader } from "@/components/common/buttons";
import { useTranslation } from "react-i18next";
import {
  TurnstileCaptcha,
  TurnstileCaptchaRef
} from "@/components/captcha/captcha";
import { useAppSelector } from "@/redux/store";
import { selectSettings } from "@/util/selectors";

export const MobileConfirm: React.FC<{
  maskedNumber: string;
  onBack: () => void;
  onConfirm: () => Promise<void>;
  mobileConfirmSendError: string;
}> = ({ maskedNumber, onBack, onConfirm, mobileConfirmSendError }) => {
  const [loading, setLoading] = useState(false);
  const [captchaLoading, setCaptchaLoading] = useState(false);
  const [isInteractiveCaptcha, setIsInteractiveCaptcha] = useState(false);
  const { t } = useTranslation("auth");
  const turnstileCaptchaToken = useAppSelector(
    state => state.authReducer.turnstileCaptchaToken
  );
  const settings = useAppSelector(selectSettings);
  const valueCaptchaFromCMS = settings?.captcha?.sendOrResendSmsOtp;
  const captchaRef = useRef<TurnstileCaptchaRef>(null);
  const isAutomaticCaptcha =
    !captchaLoading &&
    !isInteractiveCaptcha &&
    valueCaptchaFromCMS &&
    !turnstileCaptchaToken;
  const shouldShowLoader = isAutomaticCaptcha || captchaLoading;

  const handleClick = async () => {
    try {
      setLoading(true);
      await onConfirm();
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mv_block">
      <button className="mv_back" aria-label="Back" onClick={onBack}>
        <img src={BackIcon} style={{ height: "40px" }} />
      </button>

      <p className="mv_title">{t("mobileVerification")}</p>
      <p className="mv_text">
        {t("pleaseConfirm")} <b className="masked_phone">{maskedNumber}</b>
      </p>
      {valueCaptchaFromCMS && (
        <TurnstileCaptcha
          ref={captchaRef}
          className="mt-4 mb-4"
          beforeLoading={() => setCaptchaLoading(true)}
          afterLoading={() => {
            setCaptchaLoading(false);
          }}
          onInterectiveChallangeStarted={() => {
            setIsInteractiveCaptcha(true);
          }}
          onToken={() => setCaptchaLoading(false)}
          onTokenExpired={() => setCaptchaLoading(false)}
        />
      )}

      {mobileConfirmSendError && (
        <p className="error">{mobileConfirmSendError}</p>
      )}
      <ButtonWithLoader
        className="btn_black mobile_confirm_btn"
        onClick={handleClick}
        showLoader={loading || shouldShowLoader}
        disabled={loading}
        showLoaderWithoutClick={true}
      >
        {t("confirm")}
      </ButtonWithLoader>
    </div>
  );
};
